import React from 'react';
import { PropTypes } from 'prop-types';

export const CalendarIcon = (props) => {
    return (
        <svg
            fill="#fff"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            {...props}
        >
            <g fill="#989ea3" data-name="vuesax/outline/calendar">
                <path d="M8 5.75A.755.755 0 017.25 5V2A.755.755 0 018 1.25a.755.755 0 01.75.75v3a.755.755 0 01-.75.75z"></path>
                <path
                    d="M16 5.75a.755.755 0 01-.75-.75V2a.755.755 0 01.75-.75.755.755 0 01.75.75v3a.755.755 0 01-.75.75zM8.5 14.5a1 1 0 01-.38-.08 1.032 1.032 0 01-.33-.214 1.033 1.033 0 01-.29-.706 1 1 0 01.08-.38 1.155 1.155 0 01.21-.33 1.032 1.032 0 01.33-.21 1.021 1.021 0 011.09.21 1.052 1.052 0 01.29.71 1.5 1.5 0 01-.02.2.636.636 0 01-.06.18.757.757 0 01-.09.18 1.576 1.576 0 01-.12.15 1.052 1.052 0 01-.71.29zM12 14.501a1 1 0 01-.38-.08 1.032 1.032 0 01-.33-.21 1.033 1.033 0 01-.29-.71 1 1 0 01.08-.381 1.155 1.155 0 01.21-.33 1.032 1.032 0 01.33-.21 1 1 0 011.09.21 1.052 1.052 0 01.29.711 1.5 1.5 0 01-.02.2.636.636 0 01-.06.18.757.757 0 01-.09.18 1.576 1.576 0 01-.12.15 1.052 1.052 0 01-.71.29zM15.5 14.501a1 1 0 01-.38-.08 1.032 1.032 0 01-.33-.21l-.12-.15a.757.757 0 01-.09-.18.636.636 0 01-.06-.18 1.5 1.5 0 01-.02-.2 1.052 1.052 0 01.29-.711 1.032 1.032 0 01.33-.21 1 1 0 011.09.21 1.052 1.052 0 01.29.711 1.5 1.5 0 01-.02.2.636.636 0 01-.06.18.757.757 0 01-.09.18 1.576 1.576 0 01-.12.15 1.052 1.052 0 01-.71.29zM8.5 18a1 1 0 01-.38-.08 1.155 1.155 0 01-.33-.207A1.052 1.052 0 017.5 17a1 1 0 01.08-.38.933.933 0 01.21-.329 1.047 1.047 0 011.42 0A1.052 1.052 0 019.5 17a1.052 1.052 0 01-.29.71 1.052 1.052 0 01-.71.29zM12 18a1.052 1.052 0 01-.71-.287A1.052 1.052 0 0111 17a1 1 0 01.08-.38.933.933 0 01.21-.329 1.047 1.047 0 011.42 0 .933.933 0 01.21.33A1 1 0 0113 17a1.052 1.052 0 01-.29.71A1.052 1.052 0 0112 18zM15.5 17.999a1.052 1.052 0 01-.71-.29.933.933 0 01-.21-.33 1 1 0 01-.08-.38 1 1 0 01.08-.379.933.933 0 01.21-.33 1 1 0 01.9-.27.6.6 0 01.19.06.757.757 0 01.18.09 1.576 1.576 0 01.15.12 1.052 1.052 0 01.29.709 1.052 1.052 0 01-.29.71 1.052 1.052 0 01-.71.29zM20.5 9.84h-17a.755.755 0 01-.75-.75.755.755 0 01.75-.75h17a.755.755 0 01.75.75.755.755 0 01-.75.75z"
                    data-name="Vector"
                ></path>
                <path
                    d="M16 22.75H8c-3.65 0-5.75-2.1-5.75-5.75V8.5c0-3.65 2.1-5.75 5.75-5.75h8c3.65 0 5.75 2.1 5.75 5.75V17c0 3.65-2.1 5.75-5.75 5.75zM8 4.25c-2.86 0-4.25 1.39-4.25 4.25V17c0 2.86 1.39 4.25 4.25 4.25h8c2.86 0 4.25-1.39 4.25-4.25V8.5c0-2.86-1.39-4.25-4.25-4.25z"
                    data-name="Vector"
                ></path>
            </g>
        </svg>
    );
};
export const PlusIcon = (props) => {
    PlusIcon.propTypes = {
        color: PropTypes.string
    };
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22.197"
            height="22.197"
            viewBox="0 0 22.197 22.197"
            {...props}
        >
            <path
                fill={props.color || '#fff'}
                d="M34.7 25.184h-9.516V34.7h-3.171v-9.516H12.5v-3.171h9.513V12.5h3.171v9.513H34.7z"
                transform="translate(-12.5 -12.5)"
            />
        </svg>
    );
};
